var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.755,
    height: 78.961,
    viewBox: "0 0 97.755 78.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_6940026951539683259",
    "data-name": 6940026951539683000,
    transform: "translate(-1.169 -10.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M89.955,10.417H36.768A8.973,8.973,0,0,0,27.8,19.378V29.1a1.5,1.5,0,0,0,3,0V19.378a5.97,5.97,0,0,1,5.965-5.961H89.955a5.972,5.972,0,0,1,5.97,5.961V55.987a5.972,5.972,0,0,1-5.97,5.961H70.026c-.025,0-.049.006-.074.007s-.048-.007-.074-.007H56.838a1.5,1.5,0,0,0-1.5,1.5v15.5H41.02a1.5,1.5,0,0,0,0,3H85.711a1.5,1.5,0,0,0,0-3H71.379v-14H89.955a8.976,8.976,0,0,0,8.97-8.961V19.378A8.976,8.976,0,0,0,89.955,10.417ZM58.339,78.943v-14h10.04v14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M32.282,75.1A20.179,20.179,0,0,0,47.42,68.3h0a20.223,20.223,0,1,0-29.621.655L15.34,71.732l-.568-.5a1.5,1.5,0,0,0-2.111.122L1.552,83.756a1.5,1.5,0,0,0,.118,2.119L5.163,89a1.5,1.5,0,0,0,2.117-.118L18.4,76.453a1.5,1.5,0,0,0-.123-2.123l-.689-.61,2.453-2.768A20.133,20.133,0,0,0,32.282,75.1ZM6.044,85.761,4.788,84.639,13.8,74.583a1.447,1.447,0,0,0,1.331,1.031ZM19.408,43.452a17.223,17.223,0,1,1,1.454,24.313A17.184,17.184,0,0,1,19.408,43.452Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_287",
    "data-name": "Ellipse 287",
    cx: 1.79,
    cy: 1.79,
    r: 1.79,
    transform: "translate(61.685 20.833)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/noResults.2ca44f36a16ddccadb78b5f2c73b56b7.svg";
export { ForwardRef as ReactComponent };